"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_dom_1 = __importDefault(require("react-dom"));

var Root_1 = __importDefault(require("./Root"));

var react_1 = __importDefault(require("react"));

var react_modal_1 = __importDefault(require("react-modal"));

var initialized = false;

var bootstrap = function bootstrap() {
  var htmlBody = document.getElementsByTagName('body').item(0);
  var sdkDiv = document.createElement('div');
  sdkDiv.id = 'cv_sdk_container';
  htmlBody.appendChild(sdkDiv);
  react_modal_1.default.setAppElement('#cv_sdk_container');
  react_dom_1.default.render(react_1.default.createElement(Root_1.default), sdkDiv);
};

var setup = function setup(r, p) {
  initialized = true;
  read = r;
  play = p;
};

var read;
var play;
exports.default = {
  bootstrap: bootstrap,
  setup: setup,
  makeService: function makeService() {
    if (initialized) {
      return {
        read: read,
        play: play
      };
    } else {
      throw new Error('SDK is not initialized');
    }
  }
};